/**
 * Created by vladislav on 7/1/19
 */

ColorBoosterView.prototype.getAnimationPosition = function () {
    var fieldView = Game.currentGame.field.onGetView();
    return cc.p(fieldView.width / 2, fieldView.height / 2);
};